import { DsLinearWorkFormTemplateInterface } from '../interfaces/ds-linear-work-form-template.interface';

/** Class representing the link between an organisation's linear work model and a form model  */
export class DsLinearWorkFormTemplateLink {
  /**
   * Work model id.
   */
  public workId: number;

  /**
   * Form template id.
   */
  public formId: number;

  /**
   * Form template order.
   */
  public formOrder: number;

  /**
   * Creates an instance of DsLinearWorkFormTemplateLink.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsLinearWorkFormTemplateInterface = {}) {
    this.workId = jsonData.linear_work_id || this.workId;
    this.formId = jsonData.form_id || this.formId;
    this.formOrder = jsonData.form_order || this.formOrder;
  }
}
